module.exports = __webpack_public_path__ + "static/media/ProfilePic.cee34b46.jpg";